export type PageViewTrackingInvocation = {
    tracked: boolean;
    skipped: boolean;
};

export type PageViewTrackingInvocationResult = {
    tracked: boolean;
    skipped: boolean;
    superseded: boolean;
};

let activeInvocation: PageViewTrackingInvocation | null = null;

export const beginPageViewTrackingInvocation = (): PageViewTrackingInvocation => {
    activeInvocation = { tracked: false, skipped: false };
    return activeInvocation;
};

export const markPageViewTracked = (): void => {
    if (activeInvocation) {
        activeInvocation.tracked = true;
    }
};

export const markPageViewIntentionallySkipped = (): void => {
    if (activeInvocation) {
        activeInvocation.skipped = true;
    }
};

export const endPageViewTrackingInvocation = (
    invocation?: PageViewTrackingInvocation | null,
): PageViewTrackingInvocationResult => {
    // A newer transition already claimed the shared context: this invocation's marks
    // may have landed on it, so the outcome is not attributable and must not clear it.
    if (invocation && activeInvocation !== invocation) {
        return { tracked: false, skipped: false, superseded: true };
    }

    const result = {
        tracked: Boolean(activeInvocation?.tracked),
        skipped: Boolean(activeInvocation?.skipped),
        superseded: false,
    };
    activeInvocation = null;
    return result;
};
